import { type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { useHasPermission } from '@/hooks/use-permissions';
import { ForbiddenPage } from './forbidden.page';

interface RequirePermissionProps {
  /** Permission required to view the wrapped route(s). */
  permission: string;
  /** Optional explicit children; when omitted an `<Outlet />` is rendered. */
  children?: ReactNode;
}

/**
 * Route guard: renders the wrapped route(s) when the current user holds
 * `permission`, otherwise shows the {@link ForbiddenPage}.
 */
export function RequirePermission({
  permission,
  children,
}: RequirePermissionProps) {
  const allowed = useHasPermission(permission);

  if (!allowed) {
    return <ForbiddenPage />;
  }

  return <>{children ?? <Outlet />}</>;
}
